import { useController, useFormContext } from 'react-hook-form';
import { FC } from 'react';
import { MuiTelInput } from 'mui-tel-input';
import { TPhoneField } from './type';
import { useFormRules } from '../../hooks/useForm';

const PhoneField: FC<TPhoneField> = ({
  defaultValue,
  onChange,
  size = 'small',
  disabled = false,
  sx,
}) => {
  const { isPhoneValid } = useFormRules();

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const {
    field: { ref, ...inputProps },
  } = useController({
    name: 'phone',
    control,
    rules: {
      required: false,
      validate: {
        isPhoneValid,
      },
    },
    defaultValue: defaultValue || '',
  });

  const handleChange = (e: string) => {
    inputProps.onChange(e);

    if (onChange) {
      onChange(e);
    }
  };

  return (
    <MuiTelInput
      {...inputProps}
      MenuProps={{
        sx: {
          height: 400,
          width: 300,
        },
      }}
      sx={sx}
      disabled={disabled}
      onChange={handleChange}
      size={size}
      id="phone"
      fullWidth
      inputRef={ref}
      defaultCountry="US"
      error={!!errors.phone}
    />
  );
};

export {
  PhoneField,
};
